import React from 'react';
import {HashRouter as Router, Routes, Route, Navigate, useLocation} from 'react-router-dom';
import {motion, AnimatePresence} from 'framer-motion';
import Navigation from './components/Navigation';
import Footer from './components/Footer';
import HomePage from './pages/HomePage';
import ExplorePage from './pages/ExplorePage';
import Page from './pages/Page';
import WorkEntryPage from './pages/WorkEntryPage';
import SettingsPage from './pages/SettingsPage';
import AuthPage from './pages/AuthPage';
import PricingPage from './pages/PricingPage';
import NotFoundPage from './pages/NotFoundPage';
import './App.css';

function AppContent() {
  const location = useLocation();
  const hideNavAndFooter = location.pathname === '/auth';

  return (
    <div className="min-h-screen bg-slate-950 transition-colors">
      {!hideNavAndFooter && <Navigation />}
      <main className="app-main">
        <AnimatePresence mode="wait">
          <Routes location={location} key={location.pathname}>
            <Route path="/" element={<HomePage />} />
            <Route path="/explore" element={<ExplorePage />} />
            <Route path="/auth" element={<AuthPage />} />
            <Route path="/settings" element={<SettingsPage />} />
            <Route path="/pricing" element={<PricingPage />} />
            <Route path="/entry/:id" element={<WorkEntryPage />} />
            <Route path="/:username" element={<Page />} />
            
            {/* Redirect old dashboard routes */}
            <Route path="/dashboard" element={<Navigate to="/alexdoe" replace />} />
            
            <Route path="*" element={<NotFoundPage />} />
          </Routes>
        </AnimatePresence>
      </main>
      {!hideNavAndFooter && <Footer />}
    </div>
  );
}

function App() {
  return (
    <Router>
      <AppContent />
    </Router>
  );
}

export default App;